import { useContext } from 'react';

import { WizardContext } from '../WizardContext';

export function useWizard() {
  return useContext(WizardContext);
}
